
import * as React from "react";
import { IOfferListItem } from "../../../interfaces/IOffer";

interface IOfferRowProps {
    item                             : IOfferListItem
    editOfferBtnClickHandler         : IeditOfferBtnClickHandler
    openModifyDialogBtnClickHandler  : IeditOfferBtnClickHandler
    toggleDisadledDateBtnClickHandler: ItoggleDisadledDateBtnClickHandler
}

interface IeditOfferBtnClickHandler{
    (evt:any, id:number):void
}

interface ItoggleDisadledDateBtnClickHandler{
    (evt:any, id:number, name:string, isActiveToday:boolean):void
}

interface IOfferRowState {
}

export default class OfferRow extends React.Component<IOfferRowProps, IOfferRowState>{

  	constructor(props:IOfferRowProps){
        super(props);
    }


    render() {
        let item = this.props.item;
        console.log(item);
        return (
            <div className="item_row" id={'offer_row_'+item.id}>
                <div className="item_content">
                    <div className="left" onClick={e => this.props.openModifyDialogBtnClickHandler(e, item.id)}>
                        <img src = {item.offerType.img}/>
                        <p className = "service-name">{ item.offerType.name }</p>
                    </div>
                    <div className="right">
                        <div className="m-left">
                            <p className = "price">
                                { item.price } { item.currency }
                            </p>
                            <span>/hour</span>
                        </div>
                        <div className={'m-right align-self-center justify-content-end activate_toggle_btn '+ (item.isActiveToday === true?'actived':'inactived')} >
                            <button type="button" className="act_btn" onClick={e => this.props.toggleDisadledDateBtnClickHandler(e, item.id, item.name, item.isActiveToday)}>
                                &nbsp;
                            </button>
                            {/*<a className="edit_btn" onClick={e => this.props.editOfferBtnClickHandler(e, item.id)}>
                                <i className="ion-edit"></i>
                            </a>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
